import { breakpointsByName, FOUNDATION_LARGE_PX, FOUNDATION_MEDIUM_PX } from 'config/breakpoints';

export const isLarge = (width) => width >= breakpointsByName.large;
export const isSmall = (width) => width < breakpointsByName.medium;
export const isExtraLarge = (width) => width >= breakpointsByName.xlarge;
export const isFoundationLarge = (width) => width >= FOUNDATION_LARGE_PX;
export const isFoundationMedium = (width) => width >= FOUNDATION_MEDIUM_PX;


